import React from 'react';
import { MediaQueryProvider } from 'react-media-query-hoc';
var ScreenProvider = function (_a) {
    var children = _a.children, queries = _a.queries, values = _a.values;
    return (React.createElement(MediaQueryProvider, { queries: queries, values: values }, children));
};
export default ScreenProvider;
